import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { countBy } from 'lodash';
import Tippy from '@tippy.js/react';
import { LimitConditions } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';
import { conditionIndices } from './constants';
import { IconCondition } from 'svgIcons/MotionPortalIcons';

// eslint-disable-next-line react/display-name
const AssetNrByLimitsComponent = React.memo(({ asset, conditionType, isLabelVisible, leftPanelSize }) => {
    const groupedByCondition = useMemo(() => {
        const conditions = asset?.[conditionType] || [];
        return countBy(conditions, 'condition');
    }, [asset, conditionType]);
    const limits = asset?.Limits;

    const alarmCount = groupedByCondition[conditionIndices.ALARM] || 0;
    const alertCount = groupedByCondition[conditionIndices.ALERT] || 0;
    const unknownCount = groupedByCondition[conditionIndices.UNKNOWN] || 0;
    const goodCount = groupedByCondition[conditionIndices.GOOD] || 0;
    const isLeftPanelClosed = leftPanelSize > 50;

    const icon = <IconCondition condition={LimitConditions[asset?.condition]?.iconID} />;
    let count = 0;
    if (alarmCount > 0) {
        count = alarmCount;
    } else if (alertCount > 0) {
        count = alertCount;
    } else if (unknownCount > 0) {
        count = null;
    } else if (goodCount > 0) {
        count = null;
    } else {
        count = null;
    }

    const renderLimits = () => {
        const containerClass = leftPanelSize <= 50 ? 'left-panel-small' : 'limit-cell';
        return limits ?
            <div className={containerClass}>
                {icon}
                {!!count && isLabelVisible &&
                    <div className='kpis'>
                        {isLeftPanelClosed ? `${count} ${count === 1 ?
                            translate('ABB.Powertrain.Frontend.signal') :
                            translate('ABB.Powertrain.Frontend.signals')}` : null}
                    </div>
                }
            </div>
            : <div className={containerClass}>
                {asset?.condition === conditionIndices.UNKNOWN && <IconCondition condition={LimitConditions[conditionIndices.UNKNOWN].iconID} />}
            </div>;
    };

    return <div className='nr-by-condition-index'>
        <Tippy
            content={<div className='threshold-tooltip'>
                <span>{translate('ABB.Powertrain.Frontend.conditionOverviewWithAlarmLabel')} <b>{alarmCount}</b></span>
                <span>{translate('ABB.Powertrain.Frontend.conditionOverviewWithAlertLabel')} <b>{alertCount}</b></span>
            </div>}
            interactive={true}
            interactiveBorder={10}
            animation='scale'
            theme='light-border'
            trigger='mouseenter'
            maxWidth={450}
            placement='right'
            offset='-85,0'>
            <div>
                {renderLimits()}
            </div>
        </Tippy>
    </div>;
});

AssetNrByLimitsComponent.propTypes = {
    asset: PropTypes.object.isRequired,
    conditionType: PropTypes.string.isRequired,
    isLabelVisible: PropTypes.bool.isRequired,
    leftPanelSize: PropTypes.number,
};

export default AssetNrByLimitsComponent;
